import React from 'react';
import styles from './css/PlanAhead.styl';
import {CheckIcon} from './Svgs';
import sharedStyles from '../../css/Shared.styl';

const PlanAhead = () => {
  return (
    <div className={sharedStyles.Wrap}>
      <div className={styles.PlanAheadBlock}>
        <h2 className={styles.Title}>Why plan ahead?</h2>
        <div className={styles.PlanReasons}>
          <div className={styles.PlanReason}>
            <div className={styles.IconContainer}>
              <CheckIcon />
            </div>
            <div className={styles.PlanReasonDescription}>
              Ease the burden on your loved&nbsp;ones.
            </div>
          </div>
          <div className={styles.PlanReason}>
            <div className={styles.IconContainer}>
              <CheckIcon />
            </div>
            <div className={styles.PlanReasonDescription}>
              Make your final wishes&nbsp;known.
            </div>
          </div>
          <div className={styles.PlanReason}>
            <div className={styles.IconContainer}>
              <CheckIcon />
            </div>
            <div className={styles.PlanReasonDescription}>Save money.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanAhead;



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/PlanAhead/index.js